module.exports = __webpack_public_path__ + "fonts/poppins-v21-latin-regular.woff2";